module.exports = __webpack_public_path__ + "img/300X75.8cf38da1.png";